import React, { useEffect, useRef, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import Modal from "../../../components/Modal";
import LocationPage from "../pages/LocationPage";
import { useRecoEngine } from "../context/RecoEngineContext";

const LocationPageModal: React.FC = () => {
  const { state, closeModal } = useModal();
  const { 
    setShowLocationModal,
  } = useRecoEngine();
  const [isNavigating, setIsNavigating] = useState(false);
  const isNavigatingRef = useRef(false);

  const closeModalRef = useRef(closeModal);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    closeModalRef.current = closeModal;
  }, [closeModal]);

  // Reset isNavigating on mount (handles cached homepage case)
  useEffect(() => {
    setIsNavigating(false);
    isNavigatingRef.current = false;
  }, []);

  // Cleanup: ensure modal is closed when component unmounts
  useEffect(() => () => {
      closeModalRef.current();
  }, []);

  // Sync showLocationModal with ModalContext state
  useEffect(() => {
    if (state.isOpen) {
      setShowLocationModal(true);
      setIsNavigating(false); // Reset on open (handles cached case)
      isNavigatingRef.current = false;
    } else if (!isNavigatingRef.current) {
      // When modal closes (and not navigating), set showLocationModal to false
      // Use ref to check navigation state to avoid race condition
      setIsNavigating(false);
      setShowLocationModal(false);
    }
  }, [state.isOpen, setShowLocationModal]);

  // Handle navigation: close state immediately but keep visual open to prevent flash
  useEffect(() => {
    if (isNavigating) {
      isNavigatingRef.current = true; // Track navigation state
      // Close modal state immediately (ensures it's closed on cached return)
      closeModalRef.current();
      setShowLocationModal(false);
      
  // Keep modal visually open until navigation completes
      timerRef.current = window.setTimeout(() => {
        setIsNavigating(false);
        isNavigatingRef.current = false;
      }, 1000);

      return () => {
        clearTimeout(timerRef.current);
        setIsNavigating(false);
        isNavigatingRef.current = false;
      };
    }
  }, [isNavigating, setShowLocationModal]);

  return (
    <Modal
      open={state.isOpen || isNavigating} // Keep open during navigation to prevent flash
      onClose={closeModal}
      fullscreen
      classname="location-page-modal"
    >
      {isNavigating ? (
        <div className="location-page-modal-backdrop" />
      ) : (
        <LocationPage onNavigateStart={() => {
          setIsNavigating(true);
        }} />
      )}
    </Modal>
  );
};

export default LocationPageModal;